import css from 'styled-jsx/css';
import { colors, fontWeight } from '../../../themes';

export default css`
  .cta {
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 0.9rem;
    font-weight: ${fontWeight.bold};
    line-height: 1.4em;
    padding: 0.6em 0.4em 0.6em 1em;
    text-transform: uppercase;
    background: ${colors.white};
  }

  :global(.rtl) .cta {
    padding: 0.6em 1em 0.6em 0.4em;
  }

  .cta:hover,
  .cta:active {
    text-decoration: none;
  }

  :global(.rtl) .cta > :global(svg) {
    transform: rotateZ(180deg);
  }
`;



// WEBPACK FOOTER //
// ./app/NotificationsManager/email/CallToActionLink/styles.js